import React, { Component } from 'react'
import { Button, CircularProgress } from '@material-ui/core'
import { Card } from 'react-bootstrap'
import * as actions from '../../actions'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { FORM_EDICION_CONTACTO } from '../../../../config/forms'
import CamposContacto from './CamposContacto'
import isEmail from 'validator/lib/isEmail'
import { isEmpty } from 'lodash'

class DialogoContactoEdit extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isValidEmail: true,
      isValidNombre: true
    }
  }

  async componentDidMount () {
    const {
      id,
      change: formChange
    } = this.props
    this.props.editarCorreo(id, formChange)
  }

  render () {
    const {
      id,
      contacto
    } = this.props
    const {
      isValidEmail,
      isValidNombre
    } = this.state

    const handleChangeEmail = event => {
      const val = event.target.value
      console.log(val)
      if (isEmail(val)) {
        this.setState({ isValidEmail: true })
      } else {
        this.setState({ isValidEmail: false })
      }
    }

    const handleChangeNombre = event => {
      const val = event.target.value
      console.log(val)
      if (isEmpty(val)) {
        this.setState({ isValidNombre: false })
      } else {
        this.setState({ isValidNombre: true })
      }
    }

    const handleClose = () => {
      this.props.reset(FORM_EDICION_CONTACTO)
      this.props.handleClose()
    }

    const handleSubmit = () => {
      this.props.onSubmitUpdateContacto(id)
      this.props.handleClose()
    }
    return (
      <div>
        <Card style={{ border: 'none' }}>
          <Card.Header style={{ backgroundColor: '#3f51b5', color: '#ffffff' }}>
            <Card.Text style={{ fontSize: '1.3rem', textAlign: 'center' }}>Editar contacto</Card.Text>
          </Card.Header>
          <Card.Body>
            {!contacto && <div style={{ padding: '10% 0', margin: '0 auto' }} >
              <CircularProgress />
            </div> }
            {contacto &&
              <CamposContacto
                handleChangeEmail={handleChangeEmail}
                handleChangeNombre={handleChangeNombre}
              />
            }
          </Card.Body>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              style={{ margin: '2%' }}
              onClick={handleClose}
              size='medium'
              variant='contained'
              color='primary'
            >Cancelar</Button>
            {(isValidEmail && isValidNombre)
              ? <Button
                style={{ margin: '2%' }}
                size='medium'
                variant='contained'
                color='primary'
                onClick={handleSubmit}
              >Guardar</Button>
              : <Button
                style={{ margin: '2%' }}
                size='medium'
                variant='contained'
                color='primary'
                disabled
              >Guardar</Button>
            }
          </div>
        </Card>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  contacto: state.cupos.contacto
})

const withRedux = connect(mapStateToProps, actions)

export default withRedux(reduxForm({
  form: FORM_EDICION_CONTACTO,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
  updateUnregisteredFields: true
})(DialogoContactoEdit))
